import { PayoutTransferStatus } from "@modules/finances/types/financesType"
import { z } from "zod"

export const TransactionCountDtoSchema = z
  .object({
    succeededCount: z.number(),
    pendingCount: z.number(),
    pendingSepaDebitCount: z.number(),
    failedCount: z.number(),
    disputedCount: z.number(),
    refundedCount: z.number(),
    atCounterCount: z.number(),
    onlineCount: z.number(),
  })
  .meta({ id: "TransactionCountDtoSchema" })

export type TransactionCountDto = z.infer<typeof TransactionCountDtoSchema>

const CurrentBalanceDtoSchema = z.object({
  pending: z.number(),
  available: z.number(),
})

const LastPayoutDtoSchema = z.object({
  amount: z.number(),
  arrivalDate: z.string().nullable(),
  status: z.enum(PayoutTransferStatus),
})

const TransactionStatsDtoSchema = z.object({
  netTotal: z.number(),
  outOfBandTotal: z.number(),
  feesTotal: z.number(),
  refundTotal: z.number(),
  sepaDebitAmountTotal: z.number(),
  currency: z.string(),
  activeCustomers: z.number(),
  currentBalance: CurrentBalanceDtoSchema,
  lastPayout: LastPayoutDtoSchema.nullable(),
  payoutTotalAmount: z.number(),
})

const CountAndSumDtoSchema = z.object({
  count: z.number(),
  total: z.number(),
})

export const FinanceStatisticsDtoSchema = z
  .object({
    counts: TransactionCountDtoSchema,
    stats: TransactionStatsDtoSchema,
    firstPeriod: z.string().nullable(),
    isMissingDocumentsError: z.boolean(),
    toValidate: z.object({
      failed: CountAndSumDtoSchema,
      pending: CountAndSumDtoSchema,
      disputed: CountAndSumDtoSchema,
    }),
  })
  .meta({ id: "FinanceStatisticsDtoSchema" })

export type FinanceStatisticsDto = z.infer<typeof FinanceStatisticsDtoSchema>
